//:: AUTH
export const AUTH_SET_USER_ID = "AUTH_SET_USER_ID";
export const AUTH_SET_EMAIL = "AUTH_SET_EMAIL";
export const AUTH_SET_ACCESS_TOKEN = "AUTH_SET_ACCESS_TOKEN";
export const AUTH_SET_ACCESS_TOKEN_DATE = "AUTH_SET_ACCESS_TOKEN_DATE";
export const AUTH_SET_REFRESH_TOKEN = "AUTH_SET_REFRESH_TOKEN";
export const AUTH_SET_REFRESH_TOKEN_DATE = "AUTH_SET_REFRESH_TOKEN_DATE";
export const AUTH_SET_CUSTOMER_ID = "AUTH_SET_CUSTOMER_ID";
export const AUTH_SET_CUSTOMER_NAME = "AUTH_SET_CUSTOMER_NAME";
export const AUTH_SET_CUSTOMER_CONTACT_ID = "AUTH_SET_CUSTOMER_CONTACT_ID";
export const AUTH_SET_CUSTOMER_CONTACT_NAME = "AUTH_SET_CUSTOMER_CONTACT_NAME";
export const AUTH_SET_STATUS = "AUTH_SET_STATUS";
export const AUTH_SET_ERROR = "AUTH_SET_ERROR";
export const AUTH_SET_ACCESS_SESSION = "AUTH_SET_ACCESS_SESSION";
export const AUTH_SET_AUTH_TYPE = "AUTH_SET_AUTH_TYPE";

//:: CART
export const CART_PUSH_SUBMISSION = "CART_PUSH_SUBMISSION";
export const CART_REMOVE_ITEM_BY_INDEX = "CART_REMOVE_ITEM_BY_INDEX";
export const CART_REMOVE_ITEM_BY_UUID = "CART_REMOVE_ITEM_BY_UUID";
export const CART_SET_CHECKOUT_STATUS = "CART_SET_CHECKOUT_STATUS";
export const CART_SAVE = "CART_SAVE";
export const CART_CLEAR = "CART_CLEAR";
export const CART_PUSH_PRODUCT = "CART_PUSH_PRODUCT";
export const SET_LAST_PROJECT = "SET_LAST_PROJECT";
export const SET_LAST_INVOICE = "SET_LAST_INVOICE";

//:: SUBMISSION CLIPBOARD
export const SC_SET_SUBMISSION = "SC_SET_SUBMISSION";

//:: PROJECT
export const PROJECT__SET_CURRENT = "PROJECT__SET_CURRENT";

//:: PROJECT STORE
export const PROJECT_INFO_SET = "PROJECT_INFO_SET";
